import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'
import { gameIdToCashGameType, gameIdToPotLimitType } from 'utils/cashGameTable.utils'

const listParamsFromFilters = (data = {}) => {
  const params = {
    limit: data.limit,
    offset: data.offset
  }
  if (data.name) params.name = data.name
  if (data.tableName) params.name = data.tableName
  if (data.tableId != null && data.tableId !== '') params.tableId = String(data.tableId)
  if (data.status) params.status = data.status
  if (data.isActive !== undefined && data.isActive !== 'all' && data.isActive !== 'All') {
    if (data.isActive === true || data.isActive === 'true') params.status = 'active'
    else if (data.isActive === false || data.isActive === 'false') params.status = 'closed'
  }
  return params
}

const normalizeTableRow = (row = {}) => ({
  ...row,
  tableName: row.tableName ?? row.name,
  isActive: row.isActive ?? row.status === 'active',
  gameTableSettings: {
    minPlayer: row.minPlayers,
    maxPlayer: row.maxPlayers,
    minBet: row.minBet,
    maxBet: row.maxBet,
    rake: row.rake,
    currencyId: row.currencyId,
    minBuyIn: row.minBuyIn,
    maxBuyIn: row.maxBuyIn,
    smallBlindInitialBet: row.smallBlind,
    bigBlindInitialBet: row.bigBlind
  }
})

const mapCreatePayload = (data = {}) => ({
  tableName: data.tableName ?? data.name,
  gameId: data.gameId != null ? Number(data.gameId) : undefined,
  gameType: data.gameType ?? (data.gameId != null ? gameIdToCashGameType(data.gameId) : undefined),
  minPlayer: data.minPlayer ?? data.minPlayers,
  maxPlayer: data.maxPlayer ?? data.maxPlayers,
  minBet: data.minBet,
  maxBet: data.maxBet,
  currencyId: data.currencyId != null ? Number(data.currencyId) : undefined,
  minBuyIn: data.minBuyIn,
  maxBuyIn: data.maxBuyIn,
  smallBlindInitialBet: data.smallBlindInitialBet ?? data.smallBlind,
  bigBlindInitialBet: data.bigBlindInitialBet ?? data.bigBlind,
  potLimitType: data.potLimitType ?? data.betLimitType ?? (data.gameId != null ? gameIdToPotLimitType(data.gameId) : undefined),
  allowRunItTwice: data.allowRunItTwice ?? true,
  allowStraddle: data.allowStraddle ?? true,
  botsEnabled: data.botsEnabled ?? true,
  buyInConfigurationId: data.buyInConfigurationId,
  rakeConfigurationId: data.rakeConfigurationId
})

const mapUpdatePayload = (data = {}) => {
  const settings = data.gameSettings && typeof data.gameSettings === 'object' ? data.gameSettings : {}
  return {
    id: String(data.id),
    tableName: data.tableName ?? data.name,
    gameId: data.gameId != null ? Number(data.gameId) : undefined,
    gameType: data.gameType ?? (data.gameId != null ? gameIdToCashGameType(data.gameId) : undefined),
    potLimitType: data.potLimitType ?? data.betLimitType,
    isActive: data.isActive,
    status: data.status,
    gameSettings: {
      minBet: settings.minBet ?? data.minBet,
      maxBet: settings.maxBet ?? data.maxBet,
      minPlayer: settings.minPlayer ?? data.minPlayer,
      maxPlayer: settings.maxPlayer ?? data.maxPlayer,
      rake: settings.rake ?? data.rake,
      currencyId: settings.currencyId ?? data.currencyId,
      minBuyIn: settings.minBuyIn ?? data.minBuyIn,
      maxBuyIn: settings.maxBuyIn ?? data.maxBuyIn,
      smallBlindInitialBet: settings.smallBlindInitialBet ?? data.smallBlindInitialBet ?? data.smallBlind,
      bigBlindInitialBet: settings.bigBlindInitialBet ?? data.bigBlindInitialBet ?? data.bigBlind
    }
  }
}

export const getAllGameTablesService = async (data) => {
  const res = await axiosInstance(METHOD_TYPES.get, '/poker/cash-table/all', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: listParamsFromFilters(data)
  })

  if (!res || typeof res !== 'object') {
    return { count: 0, rows: [] }
  }

  return {
    count: res.count ?? 0,
    rows: Array.isArray(res.rows) ? res.rows.map(normalizeTableRow) : []
  }
}

export const getGameTableDetailsService = (tableId) => {
  return axiosInstance(METHOD_TYPES.get, '/poker/cash-table/details', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.page,
    params: { tableId: String(tableId) }
  })
}

export const createGameTableService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/poker/cash-table/create', mapCreatePayload(data), {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableCreatedSuccessfully'
  })
}

export const updateGameTableService = (data) => {
  return axiosInstance(METHOD_TYPES.put, '/poker/cash-table/update', mapUpdatePayload(data), {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    successMessage: 'tableUpdatedSuccessfully'
  })
}

export const deleteGameTableService = (tableId) => {
  return axiosInstance(METHOD_TYPES.delete, '/poker/cash-table/delete', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.submit,
    params: { tableId: String(tableId) },
    successMessage: 'tableDeletedSuccessfully'
  })
}
